export default {
  nav: {
    coreLogic: '核心逻辑',
    profitMechanism: '获利机制',
    profitFlywheel: '盈利飞轮',
    sysArch: '系统架构',
    tradingExample: '交易案例',
    cta: '开始使用',
    language: '语言 / Language',
  },
  hero: {
    badge: 'Poly Ai Claw 智能体引擎',
    title1: '从预测到',
    title2: '概率套利',
    desc: 'Polywin 通过 Poly Ai Claw 智能体引擎，将预测市场升级为系统化套利引擎',
    ctaPrimary: '开启 Poly Ai Claw 智能体引擎',
    ctaSecondary: '观看演示',
    statsEvents: '监控事件',
    statsSuccessRate: '执行成功率',
    statsExecTime: '执行时间',
    cardTitle: '概率偏差分析',
    cardBadge: 'EV 优势区',
    cardMarketProb: '市场概率',
    cardAiProb: 'AI 概率',
    cardMarketImplied: '市场隐含概率',
    cardAiTrue: 'AI 真实概率',
    cardProbDiff: '概率差优势',
  },
  coreLogic: {
    badge: 'PolyAi-Claw 决策系统',
    title1: '从数据聚合到收益复利的',
    title2: '全自动闭环',
    desc: '通过多源数据 → AI建模 → 概率偏差识别 → 自动执行 → 收益复利，构建完整的自动化交易闭环',
    step0_title: '数据层',
    step0_sub: '多源信息聚合',
    step0_i0: '政治事件',
    step0_i1: '宏观经济',
    step0_i2: '社交情绪',
    step0_i3: '盘口数据',
    step1_title: 'AI 建模',
    step1_sub: '贝叶斯概率更新',
    step1_i0: '实时数据输入',
    step1_i1: 'AI 建模引擎',
    step1_i2: '概率计算',
    step1_i3: '模型优化',
    step2_title: '偏差检测',
    step2_sub: '概率偏差识别',
    step2_i0: '市场隐含概率',
    step2_i1: 'AI 真实概率',
    step2_i2: 'EV 优势识别',
    step2_i3: '建仓信号',
    step3_title: '链上执行',
    step3_sub: 'Polygon 自动交易',
    step3_i0: '风险控制',
    step3_i1: '资金分配',
    step3_i2: 'USDC 结算',
    step3_i3: '智能合约',
    step4_title: '收益复利',
    step4_sub: '自动再投资',
    step4_i0: '事件结算',
    step4_i1: '收益清算',
    step4_i2: '复利计算',
    step4_i3: '再投资循环',
    keyTitle: '核心目标',
    keyDesc: 'PolyAi-Claw 的目标是持续寻找市场中的概率错配(Mispricing)并进行系统化套利。这一逻辑本质上与量化基金在期权市场寻找定价偏差的原理相同。',
    keyHighlight: '持续寻找市场中的概率错配(Mispricing)并进行系统化套利',
  },
  profitMechanism: {
    badge: '核心获利机制',
    title1: 'PolyAi-Claw 的',
    title2: '三大获利机制',
    desc: '通过 EV 优势识别、毫秒级执行和三级资金管理，构建稳定的概率套利系统',
    m1_title: 'EV 优势识别',
    m1_sub: 'Probability Edge Detection',
    m1_desc: '核心判断逻辑：市场价格 ≠ 真实概率。当 AI 识别到市场隐含概率与真实概率存在偏差时，自动进入 EV 优势区并触发建仓。',
    m1_marketImplied: '市场隐含概率',
    m1_aiTrue: 'AI 真实概率',
    m1_probDiff: '概率差优势',
    m1_note: '与量化基金期权套利策略原理相同',
    m2_title: '毫秒级自动执行',
    m2_sub: 'Millisecond Execution',
    m2_desc: '采用全自动执行框架，确保套利机会不会因人为操作而流失。使交易模型更接近算法交易系统。',
    m2_i0_title: '毫秒级执行速度',
    m2_i0_sub: '平均 <200ms',
    m2_i1_title: '完全链上透明',
    m2_i1_sub: 'Polygon PoS',
    m2_i2_title: '无人为干扰',
    m2_i2_sub: '智能合约自动结算',
    m2_network_label: '执行网络',
    m2_network_val: 'Polygon + USDC',
    m3_title: '三级资金管理',
    m3_sub: 'Three-Tier Risk Control',
    m3_desc: '避免传统投机行为中的高杠杆与单点风险，设计三层资金结构确保系统长期稳定运行。',
    m3_i0_title: '稳定收益池',
    m3_i0_desc: '高确定性概率套利，风险最低',
    m3_i1_title: '波动套利池',
    m3_i1_desc: '捕捉市场波动，收益弹性高',
    m3_i2_title: '对冲保护池',
    m3_i2_desc: '低相关事件对冲，降低系统风险',
    m3_risk: '单事件风险敞口 < 5%',
    formula_title: '概率差套利公式',
    formula_marketPrice: '市场价格',
    formula_aiTrue: 'AI 真实概率',
    formula_trigger: '触发建仓',
    formula_arbitrage: '套利',
    formula_hiddenPct: '隐含概率 60%',
    formula_evEdge: 'EV 优势 +12%',
    formula_autoExec: '自动执行',
  },
  fundManagement: {
    riskTitle: '风险控制核心原则',
    riskDesc: '系统设置单事件最大风险敞口 < 5%，确保即使单个事件出现极端情况，也不会对整体资金池造成重大影响。',
    riskHighlight: '单事件最大风险敞口 < 5%',
    stat_maxSingle: '最大单笔投入',
    stat_maxSingleVal: '5%',
    stat_diversify: '资金分散度',
    stat_diversifyVal: '20+ 事件',
    stat_stopLoss: '止损机制',
    stat_stopLossVal: '自动触发',
    vizTitle: '风控数据可视化',
    viz_exposure: '风险敞口控制',
    viz_diversify: '资金分散度',
    viz_correlation: '事件相关性',
    viz_stability: '策略稳定性',
  },
  techAdvantage: {
    badge: '核心优势',
    title1: '为什么 PolyAi-Claw',
    title2: '优于传统预测市场？',
    dim_decision: '决策基础',
    dim_monitor: '监控频率',
    dim_execute: '执行方式',
    dim_model: '认知模型',
    dim_risk: '风险控制',
    human_decision: '情绪驱动',
    human_monitor: '低频判断',
    human_execute: '人为下单',
    human_model: '主观认知',
    human_risk: '经验判断',
    ai_decision: '数据驱动',
    ai_monitor: '高频监控',
    ai_execute: '自动执行',
    ai_model: '概率模型',
    ai_risk: '算法管理',
    humanPredict: '人类预测',
    adv1_title: '数据驱动 vs 情绪驱动',
    adv1_desc: 'PolyAi-Claw 基于多源数据建模，包括政治事件、宏观经济、社交情绪和盘口数据，通过贝叶斯概率更新实时计算真实概率，避免人类情绪化判断。',
    adv1_label: '数据源数量',
    adv2_title: '高频监控 vs 低频判断',
    adv2_desc: '系统 24/7 不间断监控市场变化，实时识别概率偏差机会。人类无法做到持续高频监控，容易错过最佳入场时机。',
    adv2_label: '监控频率',
    adv3_title: '自动执行 vs 人为下单',
    adv3_desc: '毫秒级自动执行，通过智能合约在 Polygon 链上完成交易，无需人为操作，避免延迟和失误，确保套利机会不流失。',
    adv3_label: '执行速度',
    adv4_title: '算法管理 vs 经验判断',
    adv4_desc: '三级资金管理系统，单事件风险敞口严格控制在 5% 以下，通过低相关事件对冲策略降低系统性风险，远超人类经验判断。',
    adv4_label: '风险控制',
    conclusion_title: '从预测市场到 Poly Ai Claw 智能体引擎',
    conclusion_desc1: '这使 PolyWin 从一个简单的 Prediction Market 升级为',
    conclusion_brand: 'Poly Ai Claw 智能体引擎',
    conclusion_desc2: '即 Poly Ai Claw 智能体量化预测系统',
  },
  productNarrative: {
    badge: '产品定位',
    title: 'PolyWin 的真正定位',
    desc: 'PolyWin 并不是一个单纯的预测市场，而是一个融合 AI、预测市场、OpenClaw 和量化交易的综合系统。长期战略建立属于 polywin 的 预测平台 Polywin Market.',
    item0_title: '概率差套利系统',
    item0_sub: '持续捕捉市场定价偏差',
    item1_title: '纪律化执行模型',
    item1_sub: '自动化无情绪干扰',
    item2_title: 'AI 风险管理引擎',
    item2_sub: '智能风控保障安全',
    visual_title: '三大视觉表达',
    vis0_title: '① 概率曲线偏差图',
    vis0_desc: '展示 AI 概率曲线 vs 市场定价曲线，形成明显价格偏差区域',
    vis0_ai: 'AI 概率',
    vis0_market: '市场价格',
    vis0_diff: '概率差',
    vis1_title: '② 风控雷达图',
    vis1_desc: '展示风险敞口、资金分散、事件相关性、策略稳定性',
    vis1_exposure: '风险敞口',
    vis1_diversify: '资金分散',
    vis1_safe: '安全区域',
    vis1_safeVal: '已进入',
    vis2_title: '③ AI 自动交易流程图',
    vis2_desc: '突出数据 → AI → 执行 → 清算 → 复利的完整闭环',
    vis2_exec: '执行速度',
    vis2_execVal: '毫秒级',
    vis2_auto: '自动化率',
    vis2_compound: '复利循环',
    vis2_compoundVal: '持续',
    core_title: '核心价值主张',
    core_desc: '通过自动化概率定价与时间复利机制，PolyAi-Claw 试图在保证风险控制的前提下，持续捕捉预测市场中的定价偏差。',
    core_highlight: '自动化概率定价与时间复利机制',
    core_item0: '自动化概率定价',
    core_item1: '时间复利机制',
    core_item2: '风险控制保障',
    core_item3: '持续捕捉偏差',
  },
  profitFlywheel: {
    badge: 'AI驱动金融增长飞轮',
    title1: 'PolyWin AI',
    title2: '盈利飞轮模型',
    desc: 'PolyWin 的增长不依赖单次交易盈利，而是依赖 AI驱动的持续复利系统，形成自增强循环',
    descHighlight: 'AI驱动的持续复利系统',
    aiCore: 'AI Probability Engine',
    step1_title: '全球数据输入',
    step1_sub: 'Global Data',
    step1_desc: 'AI持续监控新闻事件、政治变化、宏观经济数据、社交情绪、预测市场盘口',
    step1_tech: '50+ 数据源',
    step1_techDetail: '多源实时信息流融合',
    step2_title: 'AI概率建模',
    step2_sub: 'Probability Modeling',
    step2_desc: '使用贝叶斯概率模型、情绪修正模型、市场定价模型计算真实概率',
    step2_tech: '贝叶斯模型',
    step2_techDetail: '动态概率实时修正',
    step3_title: '发现概率偏差',
    step3_sub: 'Probability Edge',
    step3_desc: '当AI真实概率 > 市场隐含概率时，识别为EV Positive Opportunity',
    step3_tech: 'EV 偏差 >5%',
    step3_techDetail: '正期望值自动识别',
    step4_title: '自动交易执行',
    step4_sub: 'Algorithmic Execution',
    step4_desc: '系统自动完成建仓、对冲、订单执行，交易在Polygon链上完成',
    step4_tech: '智能合约',
    step4_techDetail: '<200ms 毫秒级执行',
    step5_title: '预测市场获利',
    step5_sub: 'Market Profit',
    step5_desc: '当事件结果确认或市场概率回归时，系统获得套利收益',
    step5_tech: 'Polygon PoS',
    step5_techDetail: '链上结果自动清算',
    step6_title: '收益回收',
    step6_sub: 'Capital Recycling',
    step6_desc: '系统将盈利资金自动回收至资金池',
    step6_tech: 'USDC 结算',
    step6_techDetail: '稳定币零汇率损耗',
    step7_title: '复利增长',
    step7_sub: 'Compounding Capital',
    step7_desc: '资金池规模扩大后，AI可以参与更大市场、更多事件、更多套利机会',
    step7_tech: '自动复利',
    step7_techDetail: '收益自动再投资循环',
    step8_title: '更大资金规模',
    step8_sub: 'Larger Liquidity Pool',
    step8_desc: '更大的资金规模意味着更高交易能力、更稳定收益、更强市场影响力',
    step8_tech: '流动性扩容',
    step8_techDetail: '规模越大优势越强',
    sum0_label: '数据层',
    sum0_tech: '50+ 多源数据流',
    sum0_detail: '贝叶斯实时建模',
    sum1_label: '执行层',
    sum1_tech: '智能合约自动化',
    sum1_detail: 'Polygon PoS 链上结算',
    sum2_label: '结算层',
    sum2_tech: 'USDC 稳定币',
    sum2_detail: '零汇率损耗清算',
    sum3_label: '复利层',
    sum3_tech: '自动再投资',
    sum3_detail: '规模扩容正循环',
    key0_title: '自增强循环',
    key0_desc: '每次盈利都会增强系统能力，形成正向反馈循环，实现指数级增长',
    key1_title: 'AI驱动增长',
    key1_desc: '增长不依赖拉人，而是依赖AI系统本身的概率套利能力和复利效应',
    key2_title: '持续复利系统',
    key2_desc: '通过自动化收益回收和再投资，实现资金规模的持续扩大和收益稳定增长',
    formula_title: '飞轮增长公式',
    f0_label: 'AI数据',
    f1_label: '概率套利',
    f2_label: '获利',
    f3_label: '复利',
    f4_label: '更大资金',
    f5_label: '更多套利',
    connected: '已连接 · 实时',
  },
  sysArch: {
    badge: 'Official Architecture',
    title1: 'PolyAi-Claw AI',
    title2: '系统架构图',
    desc: '从数据采集到自动结算的完整 AI 决策系统，采用量化基金级风控模型，实现透明、自动、无人工干预的交易执行',
    coreBadge: '核心 AI 大脑',
    feat0_title: 'AI 系统结构完整',
    feat0_desc: '不是简单策略，而是完整的 AI 决策系统，涵盖数据采集、智能分析、风险控制到自动执行的全流程',
    feat1_title: '量化基金级风控',
    feat1_desc: '采用专业量化基金的风险控制模型，包括敞口控制、相关性对冲和动态资金分配',
    feat2_title: '可扩展架构',
    feat2_desc: '未来可扩展至多市场、多链、多策略，支持 Azuro、Zeitgeist、Omen 等更多预测市场',
    dataflow_title: '数据流向',
  },
  tradingExample: {
    badge: '实战案例解析',
    title1: 'PolyAi-Claw BTC',
    title2: '5分钟套利策略',
    desc: '系统只做三件事：识别异常波动 → 最后60秒概率判断 → 安全区交易',
    s1_title: 'BTC Market Data',
    s1_sub: '实时市场监控',
    s1_notice: '以下为策略触发条件示例数据',
    s1_price: '当前价格',
    s1_eg: '举例',
    s1_priceVol: '价格波动',
    s1_vol: '成交量',
    s1_depth: '订单簿深度',
    s1_trigger: '触发条件：波动 ≥ 100 USD',
    s1_met: '已满足',
    s2_title: 'PolyAi-Claw Engine',
    s2_sub: 'AI概率计算',
    s2_marketImplied: '市场隐含概率',
    s2_aiTrue: 'AI真实概率',
    s2_yes: 'YES',
    s2_probDiff: '概率差优势',
    s2_safe: '进入安全交易区',
    s3_title: 'Auto Trade + Profit',
    s3_sub: '自动执行与收益',
    s3_exec: '交易执行',
    s3_buyYes: '买入 YES',
    s3_buyPrice: '买入价格',
    s3_settlement: '预测市场结算',
    s3_correct: '正确预测',
    s3_profit: '单笔收益',
    s3_avg: '平均收益率',
    s3_recycle: '收益回收资金池',
    chart_title: 'AI概率 vs 市场概率 偏差图',
    chart_sub: '实时追踪 Poly Ai Claw 智能体引擎与市场定价的概率偏差，识别套利窗口',
    chart_live: 'Live Analysis',
    chart_curDev: '当前偏差',
    chart_signal: '套利信号',
    chart_signalVal: '触发',
    chart_winRate: '胜率预测',
    chart_bottom_implied: '市场隐含概率',
    chart_bottom_dev: '概率偏差区域',
    chart_bottom_dev_sub: '套利机会已触发',
    chart_bottom_ai: 'AI 真实概率',
    chart_bottom_ai_sub: 'Poly Ai Claw 模型输出',
    chart_bottom_implied_sub: '基于市场价格定价',
    chart_marketProb: '市场隐含概率',
    chart_aiProb: 'AI 真实概率',
    chart_deviationArea: '套利偏差区域',
    maxDeviation: '最大偏差',
    deviation: '偏差',
    flow_title: '完整策略流程',
    flow0_title: 'BTC数据监控',
    flow0_desc: '实时价格/成交量',
    flow1_title: '波动检测',
    flow1_desc: '≥ 100 USD',
    flow2_title: '时间过滤',
    flow2_desc: '最后60秒',
    flow3_title: '胜率评估',
    flow3_desc: '≥ 60-70%',
    flow4_title: '自动执行',
    flow4_desc: '买入 YES/NO',
    flow5_title: '市场结算',
    flow5_desc: '1 USDC',
    flow6_title: '收益复利',
    flow6_desc: '3%-10%',
    risk0_title: '风控结构',
    risk0_i0: '单事件资金限制 < 5%',
    risk0_i1: '多事件分散交易',
    risk0_i2: 'AI动态止损',
    risk1_title: '时间策略',
    risk1_i0: '最后60秒执行',
    risk1_i1: '避免情绪交易',
    risk1_i2: '信息更完整',
    risk2_title: '历史表现',
    risk2_i0: '历史胜率 80%-90%',
    risk2_i1: '平均收益 3%-10%',
    risk2_i2: '稳定套利模型',
  },
  crossPlatform: {
    badge: '跨预测平台套利',
    title1: 'PolyAi CLaw',
    title2: '预测市场跨平台套利逻辑',
    desc: '桥接 Polymarket（Web3）与 Kalshi（法币）双平台，捕获价格偏差，实现智能匹配 + 极速执行',
    polymarket: 'Polymarket',
    kalshi: 'Kalshi',
    web3: 'Web3',
    fiat: '法币',
    claw: 'CLaw',
    matched: '已匹配',
    matching: '匹配中...',
    sec1_badge: '01',
    sec1_accuracy: '99%+ Accuracy',
    sec1_title: '智能市场匹配',
    sec1_desc: '两个平台的事件通过语义 AI 自动绑定，毫秒级识别跨平台同标的价差',
    sec2_badge: '02',
    sec2_ms: 'Millisecond Execution',
    sec2_title: '统一集成与极速交易',
    sec2_desc: '统一 API/SDK 连接多平台，毫秒级同步下单，确保套利窗口零延误捕获',
    connected: '已连接 · 实时',
    latency: '下单延迟',
    dailyEvents: '每日匹配事件',
    successRate: '执行成功率',
    platforms: '同步平台数',
    sec3_badge: '03',
    sec3_analytics: 'Live Analytics',
    sec3_title: '套利数据可视化',
    sec3_desc: '实时价格偏差、套利收益与增长趋势，动态呈现跨平台套利价值',
    priceDeviation: '价格偏差分布',
    volumeTitle: '月度交易量 (K USDC)',
    h1Volume: 'H1 累计交易量 (USDC)',
    arbIndicators: '套利优势指标',
    arbSuccess: '价差套利成功率',
    semanticAccuracy: '语义匹配精准度',
    liquidity: '跨平台流动性',
    hedgeCoverage: '风险对冲覆盖率',
  },
  mathAlgo: {
    badge: '精密的高级数学算法',
    title1: 'Polymarket 套利并不是',
    title2: '简单的数学问题',
    quote: '当你还在手动算这道加法题的时候，量化系统已经在做一件完全不同的事。',
    quoteHighlight1: '手动算这道加法题',
    quoteHighlight2: '完全不同的事',
    ch0_title: '套利是什么？为什么 Polymarket 有这么多',
    ch0_tag: '市场低效',
    ch1_title: '跨市场套利：逻辑依赖关系',
    ch1_tag: '组合数学',
    ch2_title: 'Bregman 投影：算出最优套利量',
    ch2_tag: '凸优化',
    pipeline_title: 'Polymarket 套利系统 — 完整架构',
    layer0: '第一层：数据采集',
    layer1: '第二层：依赖关系检测',
    layer2: '第三层：三级优化引擎',
    layer3: '第四层：执行与仓位管理',
    annualProfit: '年度总提取利润：$39,688,585',
    venn_title: '逻辑依赖关系：P(大胜 5%) ⊆ P(获胜)',
    contradiction: '矛盾！P(子集) > P(父集) → 套利信号触发',
    contradiction_sub: '0.55 > 0.48 → 逻辑矛盾 → 套利机会',
    combinations: '组合市场数量',
    brutal: '暴力枚举不可能',
    integerConstraints: '整数规划约束',
    replaces: '替代 16,384 次枚举',
    bregman_title: 'KL 散度 vs 欧几里得距离',
    coreData: '核心数据',
    pipeline4: '系统四层管道',
    annualReturn: '年化利润 ≈ $3,968 万',
    whyNotEnough_title: '为什么「价格相加 = $1」不够用？',
    singleMarket: '单市场——表面正常',
    crossMarket: '跨市场——指数爆炸',
  },
  mathProfit: {
    ch3_title: 'Frank-Wolfe 算法：一步一步逼近答案',
    ch3_tag: '迭代算法',
    ch3_chapter: '第04章',
    execTitle: '非原子执行风险',
    profitStructure: '利润结构（2024.4 – 2025.4）',
    totalProfit: '总计：$39,688,585',
    top10: '其中 TOP 10 拿走 20.5%',
    kellyFormula: '改良 Kelly 仓位公式',
    preTrade: '执行前 4 道门槛',
    gate0: '流动性充足？',
    gate1: '滑点可接受？',
    gate2: '扣滑点仍盈利？',
    gate3: '利润 > $0.05 → 执行',
  },
  safuFund: {
    badge: '资产安全保障',
    title: 'Polywin SAFU 基金',
    titleHighlight: 'SAFU 基金',
    desc: '链上锁定储备，公开透明，实时可查 — 你的资产，我们守护',
    reserveLabel: 'Total Reserve · USDC · Ethereum Mainnet',
    verified: '链上已验证',
    mainDesc: 'Polywin 团队已在以太坊主网链上锁定 1000 万 USDC SAFU 安全储备基金，专项用于黑客攻击下的用户资产兜底保障。所有资金公开透明，任何人均可通过 Etherscan 实时验证。',
    mainDescHighlight: '1000 万 USDC',
    contractLabel: '合约地址',
    etherscanBtn: 'Etherscan 验证',
    stat0_label: '储备规模',
    stat0_sub: 'USDC',
    stat1_label: '链上锁定率',
    stat1_sub: 'On-Chain',
    stat2_label: '可查时间',
    stat2_sub: 'Real-time',
    stat3_label: '历史赔付',
    stat3_val: '$0',
    stat3_sub: '零损失记录',
    f0_title: '链上锁定',
    f0_desc: '资金 100% 锁定于以太坊主网智能合约，团队无权随意提取或转移',
    f1_title: '公开透明',
    f1_desc: '任何人可通过 Etherscan 实时查看资金余额与所有历史交易记录',
    f2_title: '极速赔付',
    f2_desc: '安全事件确认后 72 小时内启动赔付流程，用户资产第一时间兜底',
    f3_title: '独立审计',
    f3_desc: '第三方安全机构定期审计合约代码，确保储备金真实可信不作假',
  },
  cta: {
    badge: '立即开始',
    title1: '开始使用',
    title2: 'Poly Ai Claw',
    title3: '智能体引擎',
    desc: '无需编程经验，3 分钟完成 AI 策略配置',
    btn: '启动 AI-Claw',
    trust0: 'Polygon 官方合作',
    trust1: '审计机构认证',
    trust2: '10,000+ 活跃用户',
    trust3: '$50M+ 累计交易额',
  },
  footer: {
    tagline: 'Poly Ai Claw 智能体引擎',
    product: '产品',
    resources: '资源',
    social: '社交媒体',
    link0: 'Poly AI-Claw 算法',
    link1: '风控系统',
    link2: '数据 API',
    link3: '开发文档',
    res0: '使用教程',
    res1: '策略案例',
    res2: '白皮书',
    res3: '社区论坛',
    copyright: '© 2026 PolyWin. All rights reserved.',
    privacy: '隐私政策',
    terms: '服务条款',
  },
};
